module.exports = __webpack_public_path__ + "img/ps-18.c3ba246f.jpg";